import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const DiscountLadderLazy = loadable(() => import(/* webpackChunkName: "DiscountLadder" */ './DiscountLadderSuspense'));

export const DiscountLadderAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <DiscountLadderLazy />
    </DelayedSuspense>
);
